import axios from 'axios';

// Create an Axios instance
const apiClient = axios.create({
    // baseURL: 'http://localhost:4001/api/v1',
    baseURL: 'https://api.libaonline.com/api/v1',
});

// Attach a request interceptor to add the auth token
apiClient.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('Token'); // Retrieve the token
    if (token) {
        config.headers['authtoken'] = token; // Dynamically add the token
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default apiClient;
